import { createSlice } from '@reduxjs/toolkit'
import { requests } from '../../../core/ajax'

const guildUsersSlice = createSlice({
  name: 'guildUsers',
  initialState: {
    isLoading: false,
    data: [],
    search: {},
    pagination: {},
    selectedUser: {},
  },
  reducers: {
    setLoading: (state, { payload }) => {
      state.isLoading = payload
    },
    setUsersData: (state, { payload }) => {
      state.data = payload.data
      if (payload.search) {
        state.search = payload.search
      }
      if (payload.pagination) {
        state.pagination = payload.pagination
      }
      state.isLoading = false
    },
    setSelectedUser: (state, { payload }) => {
      state.selectedUser = payload
    },
  },
})

export const guildUsersReducer = guildUsersSlice.reducer

export const { setLoading, setUsersData } = guildUsersSlice.actions

export const setUsers = (searchParams, gremio_id) => (dispatch) => {
  const { _pagina = 1, _num_x_pagina = 20, ...restSearchParams } = searchParams
  const { get } = requests

  const config = {
    params: { ...restSearchParams, _pagina, _num_x_pagina },
  }

  dispatch(setLoading(true))
  get(`gremios/${gremio_id}/empleados`, config)
    .then(({ data }) => {
      dispatch(
        setUsersData({
          data: data.empleados,
          search: searchParams,
          pagination: {
            total_paginas: data['total_paginas'],
            total_usuarios: data['total_solicitudes'],
          },
        })
      )
    })
    .catch(({ response }) => {
      console.error('Error recuperando asociados del gremio', response)
      dispatch(setLoading(false))
    })
}
